import styled from 'styled-components';

import { TextInputAreaStyled } from 'approot/shared/styles/inputs.style';

export const TextArea = styled(TextInputAreaStyled)`
  width: 100%;
  flex: 1 1 auto;
  resize: none;
  height: auto;
  min-height: auto;
  overflow: hidden;
`;
